module.exports = __webpack_public_path__ + "img/contact_inner2-1.aab03f0a.png";